/** Up to two upper-case initials from the first two words of a name: "ana maría lópez" → "AM". */
export function getInitials(name?: string | null): string {
    if (!name) {
        return '';
    }

    return name
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((word) => [...word][0] ?? '')
        .join('')
        .toUpperCase();
}
